module.exports = __webpack_public_path__ + "img/zs17.35a9ef4f.jpg";